import React from "react";
import {
    AssessmentOutlined,
    SearchOutlined,
    TrendingUpOutlined
} from "@material-ui/icons";
import OfficeLocationIcon from '../../../../images/office-location-icon.svg';
import InvestmentDetailsIcon from "../../../../images/investment-details-icon.svg";
import {
    AccountsAndAum,
    AllocationsIcon,
    ClientsIcon, CustodiansIcon,
    FirmInfoFiltersIcon,
    IntegrationsSectionIcon,
    InvestorContactIcon, PwgFilterIcon
} from '../../shared/Icons';
import PrivateFundsIconSvg from "../../../../images/private-funds-icon.svg";
import { MdAutoAwesome } from "react-icons/md"
import RelationshipPathIconSvg from "../../../../images/relationship-path.svg";

export const DEFAULT_FILTERS = {
    'keyword_search': {
        icon: <SearchOutlined/>,
        title: 'Keyword Search',
        innerRef: 'Keywords',
        filters: [
            {key: 'Keyword Search', name: 'Keyword Search', selected: false
            }
        ]
    },
    'ai_elements': {
        icon: <MdAutoAwesome />,
        title: 'Your AI Elements',
        innerRef: 'AI Elements',
        filters: [
            {key: 'ai_elements', name: 'Search by AI Elements', selected: false
            }
        ]
    },
    'relationships': {
        icon: <img src={RelationshipPathIconSvg}/>,
        title: 'Relationships & Affinity',
        innerRef: 'Affinity Compatibility',
        filters: [
            {key: 'My Relationships', name: 'My Relationships', selected: false, tooltip: 'When yes is selected, this will display all contacts that you have indicated as a personal or professional relationship.'
            },
            {key: "My Team's Relationships", name: "My Team's Relationships", selected: false, tooltip: 'Select one or multiple members of your team to uncover who they know personally and professionally to facilitate seamless introduction opportunities.'
            },
            {key: 'Introduction Opportunities', name: 'Introduction Opportunities', selected: false, tooltip: 'When yes is selected, this will display all contacts that our AI has identified as potential introduction opportunities through members of your personal or professional relationships.'
            },
            {key: 'Your Alumni Matches', name: 'Your Alumni Matches', selected: false, tooltip: 'Find reps & contacts who went to the same colleges or universities as you.'
            },
            {key: "My Team's Relatability", name: "My Team's Relatability", selected: false, tooltip: 'Select one or multiple members of your team to find who they share alumni roots, passions, interests, societal affiliations and more.'
            },
            {key: 'Relatability Strength', name: 'Relatability Strength', selected: false, tooltip: 'Use this filter to find reps & contacts with an Affinity relatability score within a specific range.'
            },
        ]
    },
    'contact_location': {
        icon: <img src={OfficeLocationIcon
        }/>,
        title: 'Contact & Rep Location',
        innerRef: 'Contact Location',
        filters: [
            {key: 'Location', name: 'Mile Radius Search', selected: false, tooltip: 'Apply a mile radius to any location to find nearby reps & contacts.'
            },
            {key: 'Branch Office State', name: 'Branch Office State', selected: false
            },
            {key: 'Branch Office City', name: 'Branch Office City', selected: false
            },
            {key: 'Branch Office Zip', name: 'Branch Office Zip', selected: false
            },
            {key: 'Branch Office IDs', name: 'Branch Office IDs', selected: false
            },
            {key: 'Branch Office Country', name: 'Branch Office Country', selected: false
            },
            {key: 'Branch Office U.S. Regions', name: 'Branch Office U.S. Region', selected: false
            },
            {key: 'Branch Office County', name: 'Branch Office County', selected: false
            },
            {key: 'Branch Office Metro Areas', name: 'Branch Office Metro Area', selected: false
            },
            {key: 'Primary Location is Firm HQ', name: 'Primary Location is Firm HQ', selected: false, tooltip: 'Find contacts whose primary location is (or is not) their primary firm\'s headquarters location.'
            },
        ]
    },
    'contact_info': {
        icon: <InvestorContactIcon/>,
        title: 'Contact & Rep Info',
        innerRef: 'Contact',
        filters: [
            {key: 'Firm Name', name: 'Firm Name', selected: false
            },
            {key: 'Affiliated Broker Dealer', name: 'Affiliated Broker Dealer', selected: false
            },
            {key: 'Break Away Rep', name: 'Recent Breakaway Rep', selected: false, tooltip: 'Identify reps who have left a wirehouse or broker dealer and joined an independent RIA within the last year.'
            },
            {key: 'Historical Breakaway Rep', name: 'Historical Breakaway Rep', selected: false, tooltip: 'Identify reps who left a wirehouse or broker dealer to join an independent RIA at any point in their career.'
            },
            {key: 'Breakaway Reps', name: 'Breakaway Rep Tracker', selected: false, tooltip: 'Uncover reps who left a wirehouse or broker dealer to join an independent RIA within a chosen timeframe.'
            },
            {key: 'Reps On The Move', name: 'Reps On The Move', selected: false, tooltip: 'Use this filter to find reps that have either joined or departed a firm within a designated period of time.'
            },
            {key: 'Contact Type', name: 'Contact Type', selected: false, tooltip: 'Segment reps & contacts by their respective registration type(s).'
            },
            {key: 'Show Only Primary Firms', name: 'Show Only Primary Firms', selected: false
            },
            {key: 'Contact is Hybrid Rep', name: 'Contact is Hybrid Rep', selected: false
            },
            {key: 'Contact is Producing Advisor', name: 'Contact is Producing Advisor', selected: false, tooltip: 'Identify individuals offering retail wealth advisory services.'
            },
            {key: 'Wealth Team Member', name: 'Wealth Team Member', selected: false
            },
            {key: 'Contact Title Contains', name: 'Contact Title Contains', selected: false, tooltip: 'Use this filter to search all reps & contacts for specific keywords in their job titles.'
            },
            {key: 'Rep CRD', name: 'Rep CRD', selected: false
            },
            {key: 'Previous Employment CRD', name: 'Previous Employment CRD', selected: false
            },
            {key: 'Contact Roles', name: 'Contact Roles', selected: false, tooltip: 'Find reps & contacts by their current job roles & responsibilities.'
            },
            {key: 'Email is Known', name: 'Email is Known', selected: false, tooltip: 'Find contacts that have a known primary or personal email address.'
            },
            {key: 'Contact Email Domain', name: 'Contact Email Domain', selected: false
            },
            {key: 'Skills and Experience', name: 'Skills and Experience', selected: false, tooltip: 'Filter reps & contacts by their professional experience.'
            },
            {key: 'Gender', name: 'Gender', selected: false
            },
            {key: 'Age Range', name: 'Age Range', selected: false
            },
            {key: 'Education', name: 'Education', selected: false, tooltip: 'Search for reps & contacts by their undergraduate and post-graduate education history.'
            },
            {key: 'Licenses', name: 'Licenses', selected: false, tooltip: 'Find reps & contacts based on the industry-related licenses they hold.'
            },
            {key: 'Regulatory Disclosures', name: 'Regulatory Disclosures', selected: false, tooltip: 'Identify or exclude reps & contacts that have regulatory disclosures.'
            },
            {key: 'States Registered RIA', name: 'States Registered RIA', selected: false
            },
            {key: 'States Registered BD', name: 'States Registered BD', selected: false, tooltip: '*BD refers to "Broker Dealer"'
            },
            {key: 'Rep AUM is Known', name: 'Rep AUM is Known', selected: false, tooltip: 'Use this filter to identify reps, contacts & their teams\' tracked AUM.'
            },
            {key: 'Investment Committee Member', name: 'Investment Committee Member', selected: false
            },
            {key: 'CSuite Executive', name: 'CSuite Executive', selected: false
            },
            {key: 'Passions & Interests', name: 'Passions & Interests', selected: false, tooltip: 'Identify reps & contacts by activities & hobbies in which they have an interest or background.'
            },
            {key: 'Spoken Languages', name: 'Spoken Languages', selected: false, tooltip: 'Identify reps & contacts by the languages they speak.'
            },
            {key: 'Previous Employment', name: 'Previous Employment', selected: false, tooltip: 'Find reps & contacts by firms where they previously worked.'
            },
            {key: 'Industry Accolades and Accomplishments', name: 'Industry Accolades and Accomplishments', selected: false, tooltip: 'Find reps & contacts that have been named to industry top performer award lists.'
            },
            {key: 'Designations', name: 'Designations', selected: false, tooltip: 'Find reps & contacts based on the professional certifications or credentials they have earned, such as CFA or CPA.'
            },
            {key: 'Self Regulatory Organizations', name: 'Self Regulatory Organizations', selected: false, tooltip: 'Find reps & contacts based on the individual SROs to whom they report.'
            },
            {key: 'Ownership', name: 'Ownership', selected: false, tooltip: 'Find reps & contacts based on the percent ownership stake they hold in their respective firm(s).'
            },
            {key: 'Rep AUM Industry Rank', name: 'Rep AUM Industry Rank', selected: false, tooltip: 'Identify the top-ranked reps & contacts by the dollar value of assets that they & their teams manage on behalf of their clients.'
            },
            {key: 'Rep is New Hire', name: 'Rep is New Hire', selected: false, tooltip: 'Identify reps & contacts that have joined a new firm within the past 3 months.'
            },
            {key: 'Rep AUM Amount', name: 'Rep AUM Amount', selected: false, tooltip: 'Use this filter to find reps & contacts by the dollar value of assets that they & their teams manage on behalf of their clients.'
            },
            {key: 'Tenure At Current Firm (Years)', name: 'Tenure At Current Firm (Years)', selected: false, tooltip: 'Identify reps & contacts by the number of years they have been employed at their current firm.'
            },
            {key: 'Industry Tenure (Years)', name: 'Industry Tenure (Years)', selected: false, tooltip: 'Identify reps & contacts by the number of years that they have worked in the financial services industry.'
            },
        ]
    },
    'wealth_teams': {
        icon: <PwgFilterIcon/>,
        title: 'Wealth Teams',
        innerRef: 'Wealth Teams',
        filters: [
            {key: 'Location', name: 'Mile Radius Search', selected: false, tooltip: 'Apply a mile radius to any location to find nearby wealth teams.'
            },
            {key: 'Parent Firm Name', name: 'Parent Firm Name', selected: false
            },
            {key: 'Wealth Team Name', name: 'Wealth Team Name', selected: false
            },
            {key: 'Team ID', name: 'Team ID', selected: false
            },
            {key: 'City', name: 'City', selected: false
            },
            {key: 'State', name: 'State', selected: false
            },
            {key: 'Industry Accolades and Accomplishments', name: 'Industry Accolades and Accomplishments', selected: false, tooltip: 'Find entities that have been named to industry top performer award lists.'
            },
            {key: 'U.S. Regions', name: 'U.S. Regions', selected: false
            },
            {key: 'Services Provided', name: 'Services Provided', selected: false
            },
            {key: 'Country', name: 'Country', selected: false
            },
            {key: 'Clients Served', name: 'Clients Served', selected: false, tooltip: 'Find firms based on the client segments they work with (e.g. UHNWIs, family offices, entrepreneurs).'
            },
            {key: 'Investments Utilized', name: 'Investments Utilized', selected: false
            },
            {key: 'Est. Team AUM', name: 'Est. Team AUM', selected: false
            },
            {key: 'Min Account Size', name: 'Min Account Size', selected: false
            },
            {key: 'Team Size', name: 'Team Size', selected: false
            },
            {key: 'Operates as Aggregator', name: 'Operates as Aggregator', selected: false
            },
            {key: 'Recent Addition', name: 'Recent Addition', selected: false, tooltip: 'Search for all wealth teams who joined a new parent firm in the last 12 months'
            },
            {key: 'Acquisition Date', name: 'Acquisition Date', selected: false
            },
            {key: 'Previous Independent RIA', name: 'Previous Independent RIA', selected: false
            },
            {key: 'AUM at time of acquisition', name: 'AUM at Time of Acquisition', selected: false
            },
            {key: 'Employee Count at time of acquisition', name: 'Employee Count at Time of Acquisition', selected: false
            },
        ]
    },
    'firm_location': {
        icon: <img src={OfficeLocationIcon
        }/>,
        title: 'Firm Location',
        innerRef: 'Location',
        filters: [
            {key: 'Location', name: 'Mile Radius Search', selected: false, tooltip: 'Apply a mile radius to any location to find nearby firms.'
            },
            {key: 'State', name: 'State', selected: false
            },
            {key: 'Country', name: 'Country', selected: false
            },
            {key: 'U.S. Regions', name: 'U.S. Regions', selected: false
            },
            {key: 'City', name: 'City', selected: false
            },
            {key: 'County', name: 'County', selected: false
            },
            {key: 'Metro Area', name: 'Metro Area', selected: false
            },
            {key: 'Address is Private Residence', name: 'Address is Private Residence', selected: false
            },
            {key: 'Zip Code Search', name: 'Zip Code Search', selected: false
            },
            {key: 'Number of Satellite Offices', name: 'Number of Satellite Offices', selected: false
            },
        ]
    },
    'firm_info': {
        icon: <FirmInfoFiltersIcon/>,
        title: 'Firm Info',
        innerRef: 'Firm Info & Investments',
        filters: [
            {key: 'Firm Name', name: 'Firm Name', selected: false
            },
            {key: 'Firm Classification', name: 'Firm Classification', selected: false, tooltip: 'Designations given to a firm to classify the type of activities & services that comprise the majority of the firm\'s business activity.'
            },
            {key: 'Firm CRD', name: 'Firm CRD', selected: false
            },
            {key: 'Client Served', name: 'Clients Served', selected: false, tooltip: 'Find firms based on the client segments they work with (e.g., HNWIs, institutions, individuals).'
            },
            {key: 'Registration Type', name: 'Registration Type', selected: false, tooltip: 'See firms by how they are registered with regulators.'
            },
            {key: 'Capital Allocator', name: 'Capital Allocator', selected: false, tooltip: 'Identify firms that allocate capital to external private fund managers (Hedge Funds, Private Equity, Private Credit, etc.).'
            },
            {key: 'Advisory Activities', name: 'Advisory Activities', selected: false, tooltip: 'Find firms based on the advisory services that they offer their clients.'
            },
            {key: 'SEC Year Registered', name: 'SEC Year Registered', selected: false
            },
            {key: 'Client Base', name: 'Client Base', selected: false, tooltip: 'Identify firms based on whether they work with individual/family clients or institutional clients.'
            },
            {key: 'Business Activities', name: 'Business Activities', selected: false, tooltip: 'Find firms based on additional business activities that they perform.'
            },
            {key: 'Size By Employees', name: 'Size by Employees', selected: false
            },
            {key: 'Rapid Growth', name: 'Rapid Growth', selected: false, tooltip: 'Use this filter to find firms that have grown their AUM by 20% or more within the last 12 months.'
            },
            {key: 'Custom Growth Builder', name: 'Custom Growth Builder', selected: false, tooltip: 'Filter firms by growth or decline across metrics like AUM, accounts, and employee headcount over a chosen timeframe.'
            },
            {key: 'Industry Affiliations', name: 'Industry Affiliations', selected: false, tooltip: 'Find firms based on external industry entities that the firm is affiliated with.'
            },
            {key: 'Ownership Type', name: 'Ownership Type', selected: false, tooltip: 'Determine the ownership type behind firms (individuals, foreign entity, domestic entity).'
            },
            {key: 'Private Equity Backed', name: 'Private Equity Backed', selected: false
            },
            {key: 'Form of Organization', name: 'Form of Organization', selected: false, tooltip: 'Find firms based on how they are legally organized.'
            },
            {key: 'Industry Accolades and Accomplishments', name: 'Industry Accolades and Accomplishments', selected: false, tooltip: 'Find entities that have been named to industry top performer award lists.'
            },
            {key: 'TAMPs & Technology Used', name: 'TAMPs & Technology Used', selected: false, tooltip: 'Find firms based on the turnkey asset management programs (TAMPs) and technology solutions they use.'
            },
            {key: 'Financial Network Affiliation', name: 'Financial Network Affiliation', selected: false, tooltip: 'Find entities that have an affiliation to a specific Financial Network.'
            },
            {key: 'Fee Structure', name: 'Fee Structure', selected: false
            },
            {key: 'Family Office Affiliation', name: 'Family Office Affiliation', selected: false, tooltip: 'Locate firms with affiliated Family Office profiles.'
            },
            {key: 'Regulatory Disclosures', name: 'Regulatory Disclosures', selected: false, tooltip: 'Find firms with any Regulatory Disclosures.'
            },
            {key: 'Referral Network', name: 'Referral Network', selected: false, tooltip: 'Find entities that are associated with a specific Referral Network.'
            },
            {key: 'SEC vs State', name: 'SEC vs State Registered', selected: false
            },
            {key: 'Count of Employees', name: 'Count of Employees', selected: false
            },
            {key: 'Count of Broker Dealer Reps', name: 'Count of Broker Dealer Reps', selected: false
            },
            {
                key: 'Count of Insurance Licensed Reps',
                name: 'Count of Insurance Licensed Reps',
                selected: false
            },
            {
                key: 'Count of Employees Registered with State Securities Authorities',
                name: 'Count of Employees Registered with State Securities Authorities',
                selected: false
            },
            {
                key: 'Count of Employees Performing Investment Advisory',
                name: 'Count of Employees Performing Investment Advisory',
                selected: false
            },
            {key: 'Count of Reps', name: 'Count of Reps', selected: false
            },
            {key: 'Acquisition Score', name: 'Acquisition Score', selected: false, tooltip: 'This score is derived by calculating several data points, ratios and growth metrics around asset growth, producing advisor efficiency, employee growth and more.'
            },
            {key: 'Producing Advisor Concentration', name: 'Producing Advisor Concentration', selected: false, tooltip: 'Find firms based on the count and percentage of actively producing advisors within their firm.'
            },
            {key: 'Your Custom M&A Fit', name: 'Your Custom M&A Fit', selected: false, tooltip: 'Indicates the level of match between this firm and the acquisition preferences set in your FINTRX AI settings.'
            },
        ]
    },
    'accounts': {
        icon: <AccountsAndAum/>,
        title: 'Accounts & AUM',
        innerRef: 'Accounts & AUM',
        filters: [
            {key: 'Size By Assets', name: 'Size by Assets', selected: false, tooltip: 'Segment firms by the dollar value of their managed assets.'
            },
            {key: 'Assets Under Management', name: 'Assets Under Management', selected: false, tooltip: 'Segment firms by the dollar value of their managed assets within a customizable range.'
            },
            {key: 'Discretionary Assets Under Management', name: 'Discretionary Assets Under Management', selected: false, tooltip: 'Identify firms with a certain dollar value or percentage of discretionary managed assets.'
            },
            {key: 'Non-Discretionary Assets Under Management', name: 'Non-Discretionary Assets Under Management', selected: false, tooltip: 'Identify firms with a certain dollar value or percentage of non-discretionary managed assets.'
            },
            {key: 'Average Client Size by Type', name: 'Average Client Size by Type', selected: false
            },
            {key: 'Size By Accounts', name: 'Size by Accounts', selected: false, tooltip: 'Segment firms by total number of managed accounts.'
            },
            {key: 'Number of Accounts', name: 'Number of Accounts', selected: false, tooltip: 'Segment firms by total number of managed accounts within a customizable range.'
            },
            {key: 'Number of Discretionary Accounts', name: 'Number of Discretionary Accounts', selected: false, tooltip: 'Identify firms with a certain number or percentage of discretionary managed accounts.'
            },
            {key: 'Number of Non Discretionary Accounts', name: 'Number of Non Discretionary Accounts', selected: false, tooltip: 'Identify firms with a certain number or percentage of non-discretionary managed accounts.'
            },
            {key: 'Average Account Size', name: 'Average Account Size', selected: false, tooltip: 'Filter firms by the average dollar value of the firm\'s managed accounts. Taken from the firm\'s total AUM divided by its total number of accounts.'
            },
            {key: 'Average Client Size', name: 'Average Client Size', selected: false, tooltip: 'Filter firms by the average asset value per client. Taken from the firm\'s total AUM divided by its total number of clients.'
            },
        ]
    },
    'clients': {
        icon: <ClientsIcon/>,
        title: 'Clients',
        innerRef: 'Client',
        filters: [
            {key: '_title_', name: 'Assets by Client', selected: false
            },
            {key: '_title_', name: 'Total Clients', selected: false
            },
            {key: 'Individuals (Assets)', name: 'Individuals', selected: false
            },
            {key: 'Individuals (Clients)', name: 'Individuals', selected: false
            },
            {key: 'High Net Worth Individuals (Assets)', name: 'High Net Worth Individuals', selected: false
            },
            {key: 'High Net Worth Individuals (Clients)', name: 'High Net Worth Individuals', selected: false
            },
            {key: 'Banking or Thrift Institutions (Assets)', name: 'Banking or Thrift Institutions', selected: false
            },
            {key: 'Banking or Thrift Institutions (Clients)', name: 'Banking or Thrift Institutions', selected: false
            },
            {key: 'Investment Companies (Assets)', name: 'Investment Companies', selected: false
            },
            {key: 'Investment Companies (Clients)', name: 'Investment Companies', selected: false
            },
            {key: 'Business Development Companies (Assets)', name: 'Business Development Companies', selected: false
            },
            {key: 'Business Development Companies (Clients)', name: 'Business Development Companies', selected: false
            },
            {key: 'Pooled Investment Vehicles (Assets)', name: 'Pooled Investment Vehicles', selected: false
            },
            {key: 'Pooled Investment Vehicles (Clients)', name: 'Pooled Investment Vehicles', selected: false
            },
            {key: 'Retirement Plans (Assets)', name: 'Retirement Plans', selected: false
            },
            {key: 'Retirement Plans (Clients)', name: 'Retirement Plans', selected: false
            },
            {key: 'Charitable Organizations (Assets)', name: 'Charitable Organizations', selected: false
            },
            {key: 'Charitable Organizations (Clients)', name: 'Charitable Organizations', selected: false
            },
            {key: 'State or Municipal Government Entities (Assets)', name: 'State or Municipal Government Entities', selected: false
            },
            {key: 'State or Municipal Government Entities (Clients)', name: 'State or Municipal Government Entities', selected: false
            },
            {key: 'Other Investment Advisers (Assets)', name: 'Other Investment Advisers', selected: false
            },
            {key: 'Other Investment Advisers (Clients)', name: 'Other Investment Advisers', selected: false
            },
            {key: 'Insurance Companies (Assets)', name: 'Insurance Companies', selected: false
            },
            {key: 'Insurance Companies (Clients)', name: 'Insurance Companies', selected: false
            },
            {key: 'Sovereign Wealth Funds (Assets)', name: 'Sovereign Wealth Funds', selected: false
            },
            {key: 'Sovereign Wealth Funds (Clients)', name: 'Sovereign Wealth Funds', selected: false
            },
            {key: 'Corporations or Other Businesses (Assets)', name: 'Corporations or Other Businesses', selected: false
            },
            {key: 'Corporations or Other Businesses (Clients)', name: 'Corporations or Other Businesses', selected: false
            },
            {key: 'Other Clients (Assets)', name: 'Other Clients', selected: false
            },
            {key: 'Other Clients (Clients)', name: 'Other Clients', selected: false
            },
            {key: '% of Non U.S. Clients (Assets)', name: '% of Non U.S. Clients', selected: false
            },
            {key: 'Financial Planning Clients (Clients)', name: 'Financial Planning Clients', selected: false
            },
            {key: '_', name: '_', selected: false
            },
            {key: 'Total Clients (Clients)', name: 'Total Clients', selected: false
            },
        ]
    },
    'holdings': {
        icon: <img src={PrivateFundsIconSvg
        }/>,
        title: 'Holdings (13-F)',
        innerRef: 'Holdings (13-F)',
        filters: [
            {key: 'Current Holdings', name: 'Current Holdings', selected: false, tooltip: 'Search by ticker or security name to find firms holding public securities.'
            },
            {key: 'Amount Held by Holdings', name: 'Amount Held by Security', selected: false
            },
            {key: 'Industry', name: 'Industry', selected: false
            },
            {key: 'ETF Provider', name: 'ETF Provider', selected: false, tooltip: 'Identify firms holding ETFs by top providers.'
            },
            {key: 'Firm Holds', name: 'Top 10 Holding', selected: false, tooltip: 'Use this filter to find specific holdings that a firm holds as a top 10 position in their portfolio.'
            },
            {key: 'Sector', name: 'Sector', selected: false
            },
            {key: 'Holdings By Sector', name: 'Holdings by Sector', selected: false, tooltip: 'Use this filter to uncover the top sectors held by each firm.'
            },
            {key: 'Holdings By Product Type', name: 'Holdings by Product Type', selected: false, tooltip: 'Use this filter to find firms that hold specific amounts of: Stocks, EFT’s, ETN’s, and Warrants.'
            },
            {key: 'Put or Call', name: 'Put or Call', selected: false, tooltip: 'Use this filter to find firms that hold put or call option securities from specified issuers.'
            },
            {key: 'Current ETF Style/Category Weight', name: 'Current ETF Style/Category Weight', selected: false, tooltip: 'Filter ETF holdings by amount owned, style (active/passive) and category (e.g. large cap, mid cap, municipal bonds).'
            },
            {key: 'Historical ETF Portfolio Movement by Style', name: 'Historical ETF Portfolio Movement by Style', selected: false, tooltip: 'Identify increases and decreases in firms’ ETF style (active or passive) over specific timeframes.'
            },
            {key: 'Historical ETF Portfolio Management by Category', name: 'Historical ETF Portfolio Movement by Category', selected: false, tooltip: 'Identify increases and decreases in firms’ ETF categories (e.g. large cap, mid cap, municipal bonds) over specific timeframes'
            },
            {key: 'Equity/Debt', name: 'Equity/Debt', selected: false, tooltip: 'Find firms that hold securities categorized as equity and/or debt.'
            },
            {key: 'Amount Held', name: 'Amount Held', selected: false, tooltip: 'Use this filter to uncover the total amount of assets held in 13-F securities for each firm.'
            },
            {key: 'All ETF Categories', name: 'All ETF Categories', selected: false, tooltip: 'Find firms holding specific categories and asset classes of ETFs'
            },
            {
                key: 'ETF Style',
                name: 'ETF Style',
                selected: false,
                tooltip: 'Find firms holding active or passive ETFs'
            },
            {
                key: 'Top ETF Categories',
                name: 'Top ETF Categories',
                selected: false,
                tooltip: 'Find firms based on their holdings in top ETF categories such as large cap, mid cap, or municipal bonds.'
            },
            {
                key: 'ETF Investor', name: 'ETF Investor', selected: false, tooltip: 'Find firms holding ETFs'
            },
            {
                key: 'Early Adopter',
                name: 'Early Adopter',
                selected: false,
                tooltip: 'Find firms that purchased the ETF within its first year of being launched'
            },
            {
                key: 'My ETF Alignment',
                name: 'My ETF Alignment',
                selected: false,
                tooltip: 'Identify firms that are strong, moderate, or weak fits for your ETFs'
            },
            {
                key: 'ETF Win Lose',
                name: 'My ETF Matchup',
                selected: false,
                tooltip: 'Identify firms in which your ETFs are winning or losing against specified competitors.'
            },
            {
                key: 'Portfolio Growth Over Time', name: 'Portfolio Growth Over Time', selected: false
            },
            {
                key: 'Change In Holdings Over Time', name: 'Change In Holdings Over Time', selected: false
            },
            {
                key: 'Recent Open/Closed Positions',
                name: 'Recent Open/Closed Positions',
                selected: false,
                tooltip: 'This filter compares a firm\'s most recent filing to the previous quarter\'s filing to identify net new securities added or fully exited. Firms are only included if they have filed two quarters in a row — if a firm\'s last filing is more than one quarter old, it will not be included in the results.'
            },
            {
                key: 'Recent Open/Closed Categories',
                name: 'Recent Open/Closed Categories',
                selected: false,
                tooltip: 'This filter compares a firm\'s most recent filing to the previous quarter\'s filing to identify net new categories added or fully exited. Firms are only included if they have filed two quarters in a row — if a firm\'s last filing is more than one quarter old, it will not be included in the results.'
            },
        ]
    },
    'investments': {
        icon: <img src={InvestmentDetailsIcon
        }/>,
        title: 'Investment Preferences',
        innerRef: 'Investment Preferences',
        filters: [
            {key: 'Alternatives Used', name: 'Alternatives Used', selected: false, tooltip: 'Use this filter to segment firms by the specific asset classes and alternative investments they utilize in their investment strategies'
            },
            {key: 'Active ESG Investor', name: 'Active ESG Investor', selected: false, tooltip: 'Find firms that actively consider environmental, social and corporate governance (ESG) factors in their investment strategies.'
            },
            {key: 'Progressive Investment Style', name: 'Progressive Investment Style', selected: false, tooltip: 'Identify firms that are open to less traditional assets or investment strategies outside of traditional long-only investing.'
            },
            {key: 'Additional Investments Used', name: 'Additional Investments Used', selected: false, tooltip: 'Find firms that utilize mutual funds, annuities, or corporate debt in their investment strategies.'
            },
            {key: 'Active In Direct Investments', name: 'Active In Direct Investments', selected: false, tooltip: 'Identify firms with direct investments into private companies.'
            },
        ]
    },
    'assets': {
        icon: <AllocationsIcon/>,
        title: 'Asset Breakdown',
        innerRef: 'Asset Breakdown',
        filters: [
            {key: 'Asset Type', name: 'Asset Type', selected: false
            },
            {key: 'Asset Value', name: 'Asset Value', selected: false
            },
            {key: 'Cash or Cash Equivalents', name: 'Cash or Cash Equivalents', selected: false
            },
            {key: 'Derivatives', name: 'Derivatives', selected: false
            },
            {key: 'Exchange-Traded Equities Securities', name: 'Exchange-Traded Equities Securities', selected: false
            },
            {key: 'Investment Grade Corporate Bonds', name: 'Investment Grade Corporate Bonds', selected: false
            },
            {key: 'Non Exchange-Traded Equity Securities', name: 'Non Exchange-Traded Equity Securities', selected: false
            },
            {key: 'Non-Investment Grade Corporate Bonds', name: 'Non-Investment Grade Corporate Bonds', selected: false
            },
            {key: 'Public Funds/Mutual Funds', name: 'Public Funds/Mutual Funds', selected: false
            },
            {key: 'Private Funds', name: 'Private Funds', selected: false
            },
            {key: 'Sovereign Bonds', name: 'Sovereign Bonds', selected: false
            },
            {key: 'U.S. Government/Agency Bonds', name: 'U.S. Government/Agency Bonds', selected: false
            },
            {key: 'U.S. State & Local Bonds', name: 'U.S. State & Local Bonds', selected: false
            },
        ]
    },
    'custodians': {
        icon: <CustodiansIcon/>,
        title: 'Custodian Information',
        innerRef: 'Custodian Information',
        filters: [
            {key: 'Custody Assets', name: 'Custody Assets', selected: false, tooltip: 'Find firms by the specific qualified custodians they use to custody their assets and the amount held with each.'
            },
            {key: 'Custodian Affiliations Over Time', name: 'Custodian Affiliations Over Time', selected: false, tooltip: 'Use this filter to identify firms that have started or stopped using specific entities to custody their assets.'
            },
            {key: 'Private Fund Custody', name: 'Private Fund Custody', selected: false, tooltip: 'Find firms by the specific qualified custodians they use to custody their advised private fund assets.'
            },
            {key: 'Custodians Used', name: 'Custodians Used', selected: false
            },
            {key: 'Count of Qualified Custodians Used', name: 'Count of Qualified Custodians Used', selected: false
            },
            {key: 'Firm Acts As Qualified Custodian', name: 'Firm Acts as Qualified Custodian', selected: false
            },
            {key: 'Related Person Acts As Qualified Custodian', name: 'Related Person Acts as Qualified Custodian', selected: false, tooltip: 'Find firms with affiliated entities that act as qualified custodians.'
            },
        ]
    },
    'private_funds': {
        icon: <AssessmentOutlined/>,
        title: 'Private Funds Advised',
        innerRef: 'Private Funds Advised',
        filters: [
            {key: 'Private Fund Type', name: 'Private Fund Type', selected: false, tooltip: 'Segment firms by the type of private funds that they advise.'
            },
            {key: 'Private Fund is Fund of Fund', name: 'Private Fund is Fund of Fund', selected: false
            },
            {key: 'Private Fund is a Feeder Fund', name: 'Private Fund is a Feeder Fund', selected: false
            },
            {key: 'Number of Owners', name: 'Number of Owners', selected: false, tooltip: 'Use this filter to find firms based on the total number of owners for their advised private funds.'
            },
            {key: 'Total Fund Assets Advised', name: 'Total Fund Assets Advised', selected: false, tooltip: 'Segment firms based on the total asset value of their advised private funds.'
            },
            {key: 'Fund Size By Assets', name: 'Fund Size by Assets', selected: false, tooltip: 'Find firms by a specific dollar value of their individual advised private funds.'
            },
            {key: 'Total Assets Owned By Fund Type', name: 'Total Assets Owned by Fund Type', selected: false, tooltip: 'Filter firms by assets owned within specific asset classes for private funds advised.'
            },
            {key: 'Total Assets By Fund Type', name: 'Total Assets by Fund Type', selected: false, tooltip: 'Filter firms by the aggregate assets of all private funds advised within specific asset classes.'
            },
            {key: 'Minimum Investment Required', name: 'Minimum Investment Required', selected: false, tooltip: 'Filter firms by the minimum investment amount required for their advised private funds.'
            },
            {key: 'Private Fund Growth Builder', name: 'Private Fund Growth Builder', selected: false, tooltip: 'Use this filter to uncover firms that have increased or decreased the percentage of assets in different types of private funds advised over time.'
            },
        ]
    },
    'custom_props': {
        icon: <TrendingUpOutlined/>,
        title: 'Your Lists, Favorites, Tags & More',
        innerRef: 'My Custom Properties',
        filters: [
            {key: 'Lists', name: 'Lists', selected: false
            },
            {key: 'Marked As Favorite', name: 'Marked As Favorite', selected: false, tooltip: 'Identify all RIA entities & contacts that you have marked as a \"Favorite\" within FINTRX.'},{key: 'Tags', name: 'Tags', selected: false, tooltip: 'Identify all RIA\'s to which you have applied the selected Tag(s) within FINTRX.'
            },
            {key: 'My Custom Properties', name: 'My Custom Properties', selected: false
            },
        ]
    },
    'integrations': {
        icon: <IntegrationsSectionIcon/>,
        title: 'Integrations',
        innerRef: 'Integrations',
        filters: [
            {key: 'Synced Integrations', name: 'Synced Integrations', selected: false
            },
            //{key: 'Synced to Salesforce', name: 'Synced to Salesforce', selected: false},
            //{key: 'Synced to Hubspot', name: 'Synced to Hubspot', selected: false},
            //{key: 'Synced to Dynamics 365', name: 'Synced to Dynamics 365', selected: false},
            //{key: 'Synced to Ext. API', name: 'Synced to Ext. API', selected: false},
            //{key: 'Synced to DealCloud', name: 'Synced to DealCloud', selected: false},
        ]
    },
    'historical_acquisitions': {
        icon: <AssessmentOutlined/>,
        title: 'Historical Acquisitions',
        innerRef: 'Historical Acquisitions',
        filters: [
            {key: 'Date of Acquisition', name: 'Date of Acquisition', selected: false
            },
            {key: 'Acquiring Firm Name', name: 'Acquiring Firm Name', selected: false
            },
            {key: 'Acquired Firm Name', name: 'Acquired Firm Name', selected: false
            },
            {key: 'State', name: 'State', selected: false, tooltip: "Surfaces firms that have acquired firms located in the selected state(s)."
            },
            {key: 'U.S. Region', name: 'U.S. Region', selected: false, tooltip: "Surfaces firms that have acquired firms located in the selected U.S. region(s)."
            },
            {key: 'Acquired Firm AUM', name: 'Acquired Firm AUM', selected: false, tooltip: "Surfaces firms that have acquired firms whose AUM was within the specified range at the time of acquisition."
            },
            {key: 'Acquired Firm Employee Count', name: 'Acquired Firm Employee Count', selected: false, tooltip: "Surfaces firms that have acquired firms with employee counts within the specified range at the time of acquisition."
            },
            {key: 'Count of Acquisitions', name: 'Count of Acquisitions', selected: false, tooltip: "Surfaces firms based on the total number of acquisitions they have made."
            },
            {key: 'Count of Acquisitions by Date', name: 'Count of Acquisitions by Date', selected: false, tooltip: "Surfaces firms that made a specified number of acquisitions within the selected time period."
            },
            {key: 'Count of Acquisitions by AUM and Date', name: 'Count of Acquisitions by AUM and Date', selected: false, tooltip: "Surfaces firms that made a specified number of acquisitions of firms with AUM in the selected range, within the selected time period."
            },
            {key: 'Count of Acquisitions by U.S. Region', name: 'Count of Acquisitions by U.S. Region', selected: false, tooltip: "Surfaces firms that have made a specified number of acquisitions within the selected region(s)."
            }
        ]
    }
}
